module.exports = __webpack_public_path__ + "static/integra-featured-image-8b5bb3d98e17c7de901c14c01727c61a.png";